import { render, staticRenderFns } from "./industrySelect.vue?vue&type=template&id=e5631c24&scoped=true&"
import script from "./industrySelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./industrySelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./industrySelect.vue?vue&type=style&index=0&id=e5631c24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5631c24",
  null
  
)

export default component.exports